// Virtual filesystem builder for Explorer
import {
  DOCUMENTS,
  PICTURES,
  AUTO_PICTURES,
  initialTracks,
  QUOTES_PAGES,
  DOMAINS_TEXT,
} from 'content';

export function buildFS() {
  const pictures = [...(AUTO_PICTURES || []), ...(PICTURES || [])].map(p => ({
    id: p.id,
    type: 'file',
    kind: 'picture',
    name: p.title || p.id,
    src: p.src,
  }));
  const documents = (DOCUMENTS || []).map(d => ({
    id: d.id,
    type: 'file',
    kind: 'document',
    name: d.title,
  }));
  const music = (initialTracks || []).map((t, i) => ({
    id: 'track-' + i,
    type: 'file',
    kind: 'track',
    name: t?.metaData?.title || 'Track ' + (i + 1),
  }));
  const quotes = (QUOTES_PAGES || []).map((_, i) => ({
    id: 'quote-' + i,
    type: 'file',
    kind: 'quote',
    name: `Quote Page ${i + 1}`,
  }));
  const domains = (DOMAINS_TEXT || []).map((_, i) => ({
    id: 'domain-' + i,
    type: 'file',
    kind: 'domain',
    name: `Domains Page ${i + 1}`,
  }));
  return {
    name: 'Home',
    type: 'folder',
    children: [
      { name: 'Documents', type: 'folder', children: documents },
      { name: 'Pictures', type: 'folder', children: pictures },
      { name: 'Music', type: 'folder', children: music },
      { name: 'Quotes', type: 'folder', children: quotes },
      { name: 'Domains', type: 'folder', children: domains },
    ],
  };
}

export function getNode(node, path) {
  if (!path || !path.length) return node;
  if (path[0] !== node.name) return node;
  let cur = node;
  for (let i = 1; i < path.length; i++) {
    const next = cur.children?.find(
      c => c.name === path[i] && c.type === 'folder',
    );
    if (!next) return cur;
    cur = next;
  }
  return cur;
}
